var _path, _path2, _path3, _path4, _path5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCheckout(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.5 6.625V4.125C2.5 2.74428 3.61928 1.625 5 1.625H3.125C1.74428 1.625 0.625 2.74428 0.625 4.125V6.625C0.625 8.00572 1.74428 9.125 3.125 9.125H5C3.61928 9.125 2.5 8.00572 2.5 6.625Z",
    fill: "#EBEBF0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.375 7.25C9.72018 7.25 10 6.97018 10 6.625C10 6.27982 9.72018 6 9.375 6C9.02982 6 8.75 6.27982 8.75 6.625C8.75 6.97018 9.02982 7.25 9.375 7.25Z",
    fill: "#303261"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M3.125 9.75H9.375C11.0982 9.75 12.5 8.34812 12.5 6.625V4.125C12.5 2.40188 11.0982 1 9.375 1H3.125C1.40188 1 0 2.40188 0 4.125V6.625C0 8.34812 1.40188 9.75 3.125 9.75ZM1.25 4.125C1.25 3.09113 2.09113 2.25 3.125 2.25H9.375C10.4089 2.25 11.25 3.09113 11.25 4.125V6.625C11.25 7.65887 10.4089 8.5 9.375 8.5H3.125C2.09113 8.5 1.25 7.65887 1.25 6.625V4.125Z",
    fill: "#303261"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M3.125 4.75H9.375C9.72019 4.75 10 4.47019 10 4.125C10 3.77981 9.72019 3.5 9.375 3.5H3.125C2.77981 3.5 2.5 3.77981 2.5 4.125C2.5 4.47019 2.77981 4.75 3.125 4.75Z",
    fill: "#F16D5C"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M14.125 12.25H12.875C12.5304 12.25 12.25 11.9696 12.25 11.625C12.25 11.2804 12.5304 11 12.875 11H14.125C14.4702 11 14.75 10.7202 14.75 10.375C14.75 10.0298 14.4702 9.75 14.125 9.75H12.875C11.8412 9.75 11 10.5911 11 11.625C11 12.6589 11.8412 13.5 12.875 13.5H14.125C14.4697 13.5 14.75 13.7804 14.75 14.125C14.75 14.4696 14.4697 14.75 14.125 14.75H6.625C6.27981 14.75 6 15.0298 6 15.375C6 15.7202 6.27981 16 6.625 16H14.125C15.1589 16 16 15.1589 16 14.125C16 13.0911 15.1589 12.25 14.125 12.25Z",
    fill: "#F16D5C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckout);
export default __webpack_public_path__ + "static/media/checkout.d429305caeee48695b84cb9cf6ba1ccf.svg";
export { ForwardRef as ReactComponent };